import api from '@pray/shared/utils/api';

export type GmailPostmasterStats = {
  spam_rate: number | null;
  delivery_error_rate: number | null;
  spf_success_rate: number | null;
  dkim_success_rate: number | null;
  dmarc_success_rate: number | null;
  outbound_encryption_rate: number | null;
  feedback_loop_spam_rate: number | null;
};

export type GmailComplianceStatus = {
  spf: 'COMPLIANT' | 'NON_COMPLIANT' | 'UNKNOWN';
  dkim: 'COMPLIANT' | 'NON_COMPLIANT' | 'UNKNOWN';
  dmarc: 'COMPLIANT' | 'NON_COMPLIANT' | 'UNKNOWN';
};

export type EmailHealthGmailResponse = {
  domain: string;
  stats: GmailPostmasterStats | null;
  compliance: GmailComplianceStatus | null;
  available_domains: string[];
};

export type GetEmailHealthGmailParams = {
  domain?: string;
  start_date: string;
  end_date: string;
};

export async function getEmailHealthGmail({
  domain,
  start_date,
  end_date,
}: GetEmailHealthGmailParams): Promise<EmailHealthGmailResponse> {
  const params: Record<string, string> = { start_date, end_date };

  if (domain) params.domain = domain;

  const url = '/web/studio/system-check/email-health/gmail';
  const response = await api.executeGetRequest<{ data: EmailHealthGmailResponse }>(url, params);

  return response.data.data;
}
